import React from 'react'
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    WarningModalBackground,
    WarningModalContent,
} from '../../components/ui/Modal';
import {ModalDefaultBtn, WarningModalActiveBtn} from "../../components/ui/Button";
import {Caption4} from "../../components/Font";

export interface ModalProps {
    onClose: () => void
    onSubmit: () => void
}

export const WarningModal = ({
                                 onClose,
                                 onSubmit
                             }: ModalProps) => {
    return <WarningModalBackground>
        <WarningModalContent>
            <ModalHeader>
                <ModalTitle>
                    Вы уверены, что хотите изменить удостоверение личности?
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Caption4>
                    После этого вам нужно будет снова подтвердить свой аккаунт через Госуслуги или услугу МФЦ
                </Caption4>
            </ModalBody>
            <ModalFooter>
                <ModalDefaultBtn onClick={onClose}>
                    Отмена
                </ModalDefaultBtn>
                <WarningModalActiveBtn onClick={onSubmit}>
                    {'Да'}
                </WarningModalActiveBtn>
            </ModalFooter>
        </WarningModalContent>
    </WarningModalBackground>
}
